import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import './ActiveSamplePanel.css';

import { useAuth } from '../../../hook/useAuth';
import { useSample } from '../../../hook/useSample';
import WorkspacePanel, { WorkspacePanelHead } from '../../../components/WorkspacePanel/WorkspacePanel';
import CardInfo from '../../../components/CardInfo/CardInfo';
import SampleInfo from '../../../components/SampleInfo/SampleInfo';
import EditSampleBlock from '../../../components/EditSampleBlock/EditSampleBlock';
import SimpleButton, { ButtonTypes } from '../../../components/SimpleComponents/SimpleButton';

/**
 * Sample information panel
 * @component
 */
const ActiveSamplePanel = ({ sample, onSelect, onUpdate }) => {
	const [editing, setEditing] = useState(false);
	const { user } = useAuth();
	const { updateSample } = useSample();

	useEffect(() => {
		setEditing(false);
	}, [sample]);

	const is_owner = sample.owner_id === user?.id;

	return (
		<WorkspacePanel className="active-sample">
			<WorkspacePanelHead title={sample.card.name}>
				<SimpleButton
					title="Close sample information"
					type={ButtonTypes.DEFAULT}
					value="Close"
					onClick={() => {
						onSelect(null);
					}}
				/>
			</WorkspacePanelHead>
			<CardInfo card={sample.card}>
				{(editing && (
					<div className="edit-sample-wrapper">
						<EditSampleBlock
							card={sample.card}
							language_default="en"
							sample={sample}
							onCancel={handleCancelEditSample}
							onConfirm={handleUpdateSample}
						/>
					</div>
				)) || (
					<SampleInfo
						isOwned={is_owner}
						sample={sample}
						onDelete={handleDeselect}
						onMove={handleDeselect}
						onStartEdit={handleStartEdit}
					/>
				)}
			</CardInfo>
		</WorkspacePanel>
	);

	function handleDeselect() {
		onSelect(null);
	}
	function handleStartEdit() {
		setEditing(true);
	}
	function handleCancelEditSample() {
		setEditing(false);
	}

	function handleUpdateSample(qty, condition, finish, note, language, _) {
		updateSample(sample.id, sample.storage_id, qty, condition, finish, note, language, (sample) => {
			setEditing(false);
			onUpdate(sample);
		});
	}
};

ActiveSamplePanel.propTypes = {
	// Sample object
	sample: PropTypes.object.isRequired,
	// Callback function on sample select
	onSelect: PropTypes.func.isRequired,
	// Callback function on sample update
	onUpdate: PropTypes.func.isRequired,
};

export default ActiveSamplePanel;
